module.exports = __webpack_public_path__ + "img/title-xmxx.a294e68e.png";